import { Loader } from '@mantine/core';
import { PropsWithChildren } from 'react';

interface IPropsA extends PropsWithChildren {
  loading: boolean;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  skeleton?: never;
}

interface IPropsB extends PropsWithChildren {
  loading: boolean;
  skeleton: JSX.Element;
  size?: never;
}

export const Loading = ({
  loading,
  children,
  skeleton,
  size = 'md',
}: IPropsA | IPropsB) => {
  if (skeleton) {
    if (loading) {
      return <>{skeleton}</>;
    }

    return <>{children}</>;
  }

  if (loading) {
    return (
      <div className="w-full flex items-center justify-center p-8">
        <Loader size={size} />
      </div>
    );
  }

  return <>{children}</>;
};

export const Spinner = ({
  size,
}: {
  size: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | number;
}) => (
  <div className="w-full h-[40rem] flex items-center justify-center p-8">
    <Loader size={size} />
  </div>
);
